angular.module('mychart').factory('PersonRepository',
    ['AprimaRestangular', 'MetadataRepository', function (AprimaRestangular, MetadataRepository) {
        'use strict';

        var getDetails = function getDetails(uid) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('person/' + uid + '/details').get();
        };

        var updateDetails = function updateDetails(uid, request) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('person/' + uid + '/details').customPUT(request);
        };

        var getPatientDetailsMetadata = function getPatientDetailsMetadata($scope) {
            return MetadataRepository.getMetadata('patientdetails', $scope);
        };

        var getPatient = function getPatient(uid) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('person', uid).get();
        };

        var searchPharmacies = function searchPharmacies(uid, zip, phoneNumber){
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('person', uid).customGET( 'pharmacy', {zip:zip, phoneNumber:phoneNumber});
        };


        var getImmunizations = function getImmunizations(uid, typeUid) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('person/' + uid + '/immunizations').get({immunizationType: typeUid});
        };

        var getProblems = function getProblems(uid) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('person/' + uid + '/problems').get();
        };

        var getProcedures = function getProcedures(uid) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('person/' + uid + '/procedures').get();
        };

        function getLabResults(uid) {
        var restangular = AprimaRestangular.get('patient');
            return restangular.one('person/' + uid + '/labresults').get();
        }

        function getNewLabResults(uid) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('person/' + uid + '/labresults?newlabs=true').get();
        }

        function getRemarks(uid) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('person/' + uid + '/remarks').get();
        }

        function getRecentVisits(uid) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('person/' + uid + '/recentvisits').get();
        }

        var getAppointments = function getRecentVisits(uid) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('person/' + uid + '/appointments').get();
        };

        function getOrders(uid) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('person/' + uid + '/orders').get();
        }

        function getHealthMaintenanceReminders(uid) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('person/' + uid + '/healthmaintenancereminders').get();
        }

        function getBilling(uid) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('person/' + uid + '/billing').get();
        }

        function getReferenceMaterial(reportRequestDto) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('person/' + reportRequestDto.PatientId).customGET('reference-material', reportRequestDto);
        }

        function getMedicationAllergies(patientId) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('person/' + patientId + '/medication-allergies').get();
        }

        function getAttachmentPdf(userId, attachmentId) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('person/' + userId + '/attachment-pdf/' + attachmentId).get();
        }

        function getReferenceMaterialAttachment(userId, attachmentId) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('person/' + userId + '/reference-material-attachment/' + attachmentId).get();
        }

        function getAttachment(userId, attachmentId) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('person/' + userId + '/attachment/' + attachmentId).get();
        }

        function getObservationOrderPdf(userId, resultId) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('person/' + userId + '/observation-order-pdf/' + resultId).get();
        }

        function getObservationOrderPdfImage(userId, resultId, requestSettings) {
            var restangular = AprimaRestangular.get('patient');
            var queryString = '?page=' + requestSettings.page + '&height=' + requestSettings.height + '&width=' + requestSettings.width;

            return restangular.one('person/' + userId + '/observation-order-pdf/' + resultId + queryString).get();
        }

        function getCCDHtml(reportRequestDto) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('person/' + reportRequestDto.PatientId + '/ccd').customGET('html', reportRequestDto);
        }

        function postCCDHtmlDownloaded(reportRequestDto) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('person/' + reportRequestDto.PatientId + '/ccd/html').customPOST(reportRequestDto);
        }

        function getCDAXml(reportRequestDto) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('person/' + reportRequestDto.PatientId + '/ccd').customGET('xml', reportRequestDto);
        }

        function getCompleteChart(userId) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('person/' + userId + '/complete-chart').get();
        }

        function getCompleteChartImage(userId, requestSettings) {
            var restangular = AprimaRestangular.get('patient');
            var queryString = '?page=' + requestSettings.page + '&height=' + requestSettings.height + '&width=' + requestSettings.width;
            return restangular.one('person/' + userId + '/complete-chart/' + queryString).get();
        }

        function getVisitSummary(userId, visitId) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('person/' + userId + '/visit-summary/' + visitId).get();
        }

        function getVisitSummaryImage (userId, visitId, requestSettings) {
            var restangular = AprimaRestangular.get('patient');
            var queryString = '?page=' + requestSettings.page + '&height=' + requestSettings.height + '&width=' + requestSettings.width;

            return restangular.one('person/' + userId + '/visit-summary/' + visitId + queryString).get();
        }

        function getVisitSummaryUrl(patientId, visitId) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('person/' + patientId + '/visit-summary-url/' + visitId).get();
        }

        function getVisitSummaries (userId) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('person/' + userId + '/visit-summaries').get();
        }

        function postImmunizationAudit(reportRequestDto){
            var restangular = AprimaRestangular.get('patient');
            return restangular.one( 'audit-patient-access/' + reportRequestDto.PatientId + '/immunizations').customPOST(reportRequestDto);
        }

        function postClinicalSummaryAudit(reportRequestDto){
            var restangular = AprimaRestangular.get('patient');
            return restangular.one( 'audit-patient-access/' + reportRequestDto.PatientId + '/clinical-summary').customPOST(reportRequestDto);
        }

        function postDemographicsAudit(reportRequestDto){
            var restangular = AprimaRestangular.get('patient');
            return restangular.one( 'audit-patient-access/' + reportRequestDto.PatientId + '/demographics').customPOST(reportRequestDto);
        }

        function postLabResultAudit(reportRequestDto){
            var restangular = AprimaRestangular.get('patient');
            return restangular.one( 'audit-patient-access/' + reportRequestDto.PatientId + '/lab-results').customPOST(reportRequestDto);
        }

        function postMedicalHistoryAudit(reportRequestDto){
            var restangular = AprimaRestangular.get('patient');
            return restangular.one( 'audit-patient-access/' + reportRequestDto.PatientId + '/medical-history').customPOST(reportRequestDto);
        }

        function postMedicationAllergiesAudit(reportRequestDto){
            var restangular = AprimaRestangular.get('patient');
            return restangular.one( 'audit-patient-access/' + reportRequestDto.PatientId + '/medication-allergies').customPOST(reportRequestDto);
        }

        function postProcedureAudit(reportRequestDto){
            var restangular = AprimaRestangular.get('patient');
            return restangular.one( 'audit-patient-access/' + reportRequestDto.PatientId + '/procedures').customPOST(reportRequestDto);
        }

        function postEducationalMaterialAudit(reportRequestDto){
            var restangular = AprimaRestangular.get('patient');
            return restangular.one( 'audit-patient-access/' + reportRequestDto.PatientId + '/educational-material').customPOST(reportRequestDto);
        }

        function postChartAudit(reportRequestDto){
            var restangular = AprimaRestangular.get('patient');
            return restangular.one( 'audit-patient-access/' + reportRequestDto.PatientId + '/complete-chart').customPOST(reportRequestDto);
        }

        return {
            getDetails: getDetails,
            getPatientDetailsMetadata: getPatientDetailsMetadata,
            updateDetails: updateDetails,
            getImmunizations: getImmunizations,
            getPatient: getPatient,
            searchPharmacies: searchPharmacies,
            getAppointments: getAppointments,
            getProblems: getProblems,
            getProcedures: getProcedures,
            getLabResults: getLabResults,
            getNewLabResults: getNewLabResults,
            getRemarks: getRemarks,
            getRecentVisits: getRecentVisits,
            getOrders: getOrders,
            getVisitSummaries: getVisitSummaries,
            getHealthMaintenanceReminders: getHealthMaintenanceReminders,
            getBilling: getBilling,
            getReferenceMaterial: getReferenceMaterial,
            getMedicationAllergies: getMedicationAllergies,
            getAttachmentPdf: getAttachmentPdf,
            getAttachment: getAttachment,
            getObservationOrderPdf: getObservationOrderPdf,
            getObservationOrderPdfImage: getObservationOrderPdfImage,
            getCompleteChart: getCompleteChart,
            getCompleteChartImage: getCompleteChartImage,
            getCCDHtml: getCCDHtml,
            postCCDHtmlDownloaded: postCCDHtmlDownloaded,
            getCDAXml: getCDAXml,
            getVisitSummary: getVisitSummary,
            getVisitSummaryImage: getVisitSummaryImage,
            getVisitSummaryUrl: getVisitSummaryUrl,
            getReferenceMaterialAttachment: getReferenceMaterialAttachment,
            postImmunizationAudit : postImmunizationAudit,
            postClinicalSummaryAudit : postClinicalSummaryAudit,
            postDemographicsAudit : postDemographicsAudit,
            postLabResultAudit : postLabResultAudit,
            postMedicalHistoryAudit : postMedicalHistoryAudit,
            postMedicationAllergiesAudit : postMedicationAllergiesAudit,
            postProcedureAudit : postProcedureAudit,
            postEducationalMaterialAudit : postEducationalMaterialAudit,
            postChartAudit : postChartAudit
        };
    }]);

